import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('upload', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.35355 2.14645L8.28431 2.08859C8.08944 1.9536 7.82001 1.97288 7.64645 2.14645L4.14645 5.64645L4.08859 5.71569C3.9536 5.91056 3.97288 6.17999 4.14645 6.35355L4.21569 6.41141C4.41056 6.5464 4.67999 6.52712 4.85355 6.35355L7.5 3.707V10.5L7.50806 10.5899C7.55039 10.8231 7.75454 11 8 11C8.27614 11 8.5 10.7761 8.5 10.5V3.707L11.1464 6.35355L11.2157 6.41141C11.4106 6.5464 11.68 6.52712 11.8536 6.35355C12.0488 6.15829 12.0488 5.84171 11.8536 5.64645L8.35355 2.14645ZM3 9.5C3 9.22386 2.77614 9 2.5 9C2.22386 9 2 9.22386 2 9.5V12.5C2 13.3284 2.67157 14 3.5 14H12.5C13.3284 14 14 13.3284 14 12.5V9.5C14 9.22386 13.7761 9 13.5 9C13.2239 9 13 9.22386 13 9.5V12.5C13 12.7761 12.7761 13 12.5 13H3.5C3.22386 13 3 12.7761 3 12.5V9.5Z",
    fill: props.colors[0]
  }));
});